<div class="modal-header">
  <h4 class="modal-title"> {{'global.label.reassign' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{infoLabel | translate}}</p>
    <div class="mb-3 row">
      <label class="col-md-4 col-form-label" for="userName">{{'changeProjectOwnerPopup.label.userName' | translate}}:</label>
      <div class="col-md-8">
        <input type="text" id="userName" name="text-input"
          class="form-control"
          [(ngModel)]="ownerName"
          (keydown.enter)="changeOwner()"
          appInputAutoFocus>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button class="btn btn-primary btn-forward" [disabled]="!ownerName || ownerName.length <= 4" (click)="changeOwner()">
    {{'changeProjectOwnerPopup.button.assignTo' | translate}}
  </button>
</div>
